import { MainLayout } from '../../design-system/Templates';
import { Footer } from '@/design-system/Organisms';
import { QuestionnairesTemplate } from '@/design-system/Templates';

const Questionnaires = () => {

    return (
        <MainLayout
            header={null}
            sidebar={null}
            className=""
            footer={<Footer config={{ showTopSection: false }} />}
            topBanner={null}
        >
            <QuestionnairesTemplate />
        </MainLayout >
    );
};

export default Questionnaires;
